import style from "./switch.module.scss";

function Switch({id, val = 0, handleClick, label = ""}) {
    return (
        <div className={style.container}>
            <input type="checkbox" id={id} onChange={handleClick} className={style.switch} checked={val}/>
            <label htmlFor={id} className={style.label}></label>
            <div htmlFor={id} className={[style.switchBg, label && style.withText].join(" ")}>
                {label}
            </div>
            <div  className={style.switchDog}></div>

        </div>
    );
}

export default Switch;